// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"564c474e","538":"b0cb72c7","732":"b9b9fb66","834":"ada0d266"}[chunkId] + ".chunk.css";
};